import {
  axiosGetWithCookies,
  axiosPostWithCookies,
  axiosPutWithCookies,
  axiosPatchWithCookies,
} from './helper';
import { startOfDay, endOfDay } from 'utils/time';

export const fetchEventList = ({
  category,
  type,
  status,
  dateFrom,
  dateTo,
  businessClient,
  distribution,
  search,
  from,
  timezone,
  incidentStatus,
  archived,
  severityRating,
  assigneeId,
  creatorId,
  includeUnAssigned = false,
}) => {
  let query = '/events/events?sort=publishing.lastUpdatedAt:desc&limit=50';
  // incident status is always an array of objects with id and name
  if (Array.isArray(incidentStatus)) {
    /* eslint-disable no-param-reassign */
    query += incidentStatus.reduce(
      (acc, c) => (acc += `&incidentStatus=${c.id}`),
      '',
    );
  }
  if (Array.isArray(severityRating)) {
    query += severityRating.reduce(
      (acc, c) => (acc += `&severityRating=${c.id}`),
      '',
    );
  }
  if (category) {
    /* eslint-disable no-param-reassign */
    query += Array.isArray(category)
      ? category.reduce((acc, c) => (acc += `&category=${c}`), '')
      : `&category=${category}`;
  }
  if (type) query += `&eventType=${type?.typeName}`;
  if (status) query += `&publishStatus=${status}`;
  if (dateFrom) {
    const startFrom = startOfDay({
      date: dateFrom,
      timezone: timezone || 'Asia/Dili',
    });
    query += `&fromDate=${startFrom}`;
  }
  if (dateTo) {
    const endAt = endOfDay({
      date: dateTo,
      timeZone: timezone || 'Asia/Dili',
    });
    query += `&toDate=${endAt}`;
  }
  if (businessClient) query += `&involvedCompany=${businessClient}`;
  if (distribution) query += `&distribution=${distribution}`;
  if (from) query += `&from=${from}`;
  if (search) query += `&search=${search}`;
  if (archived) query += `&includeArchived=${archived}`;
  if (assigneeId) query += `&assigneeId=${assigneeId}`;
  if (creatorId) query += `&creatorId=${creatorId}`;
  if (includeUnAssigned) query += `&includeUnassigned=true`;
  return axiosGetWithCookies(query);
};

export const fetchEventListPdf = ({
  category,
  type,
  status,
  dateFrom,
  dateTo,
  businessClient,
  distribution,
  search,
  timezone,
  incidentStatus,
  language,
}) => {
  let query = '/events/events/pdf?sort=eventStartTime:asc&limit=50';
  if (Array.isArray(incidentStatus)) {
    /* eslint-disable no-param-reassign */
    query += incidentStatus.reduce(
      (acc, c) => (acc += `&incidentStatus=${c.id}`),
      '',
    );
  }
  if (category) query += `&category=${category}`;
  if (type) query += `&eventType=${type}`;
  if (status) query += `&publishStatus=${status}`;
  if (dateFrom) {
    const startFrom = startOfDay({
      date: dateFrom,
      timezone: timezone || 'Asia/Dili',
    });
    query += `&fromDate=${startFrom}`;
  }
  if (dateTo) {
    const endAt = endOfDay({
      date: dateTo,
      timeZone: timezone || 'Asia/Dili',
    });
    query += `&toDate=${endAt}`;
  }
  if (businessClient) query += `&involvedCompany=${businessClient}`;
  if (distribution) query += `&distribution=${distribution}`;
  if (timezone) query += `&timezone=${timezone}`;
  if (search) query += `&search=${search}`;
  if (language) query += `&language=${language}`;

  return axiosGetWithCookies(query);
};

export const fetchEventDetails = id =>
  axiosGetWithCookies(`/events/events/${id}`);

export const fetchEventDetailsPdf = ({ id, timezone, language }) => {
  let query = `/events/events/${id}/pdf`;

  if (timezone) query += `?timezone=${timezone}`;
  if (language) query += `&language=${language}`;

  return axiosGetWithCookies(query);
};

export const addEvent = event =>
  axiosPostWithCookies(`/events/events`, {
    data: event,
  });

export const updateEvent = (id, event) =>
  axiosPutWithCookies(`/events/events/${id}`, {
    data: event,
  });

export const uploadMedia = (media, id) =>
  axiosPostWithCookies(`/events/events/${id}/media`, {
    data: media,
  });

export const updateEventDistribution = (id, distribution) =>
  axiosPatchWithCookies(`/events/events/${id}/distribution`, {
    data: {
      distribution: distribution,
    },
  });

export const assignEventToPersonnel = (id, personnel) =>
  axiosPatchWithCookies(`/events/events/${id}/assign`, {
    data: {
      general: personnel,
    },
  });

export const sendEventForReview = id =>
  axiosPatchWithCookies(`/events/events/${id}/publish/request`);

export const approveEvent = (approver, id) =>
  axiosPatchWithCookies(`/events/events/${id}/publish/approve`, {
    data: { general: approver },
  });

export const rejectEvent = (approver, eventId) =>
  axiosPatchWithCookies(`/events/events/${eventId}/publish/reject`, {
    data: { general: approver },
  });

export const setInappropriate = (eventId, reason, description) =>
  axiosPostWithCookies(`/events/events/${eventId}/flag-inappropriate`, {
    data: {
      reason,
      description,
    },
  });

export const fetchEventTypes = ({ category, archived, search, from }) => {
  let query = 'limit=50';

  if (Array.isArray(category)) {
    /* eslint-disable no-param-reassign */
    query += category.reduce((acc, c) => `${acc}&category=${c.id}`, '');
  } else if (category) {
    query += `&category=${category}`;
  }

  if (archived) {
    query += `&includeArchived=${archived}`;
  }
  if (from) query += `&from=${from}`;
  if (search) query += `&search=${search}`;
  return axiosGetWithCookies(`/events/event-types?${query}`);
};
export const createEventType = eventType => {
  return axiosPostWithCookies(`/events/event-types`, {
    data: eventType,
  });
};
export const updateEventType = eventType => {
  return axiosPatchWithCookies(`/events/event-types`, {
    data: eventType,
  });
};
